import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoCondiciones from "../servicios/InfoCondiciones";
const Footer = lazy(() => import('../footer/Footer'));
function Condiciones() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai cuida tu inversión a través de la mejor garantía transferible del mercado, 10 años o 160000 Km"
        />
        <meta name="keywords" content="garantía Hyundai" />
        <title>Condiciones de garantía</title>
      </Helmet>
      <Menu />
      <InfoCondiciones />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Condiciones;